import { put, all, select } from "redux-saga/effects";
import selectors from "rdx/modules/tickets/selectors";
import rbacSelectors from "rdx/modules/rbac/selectors";
import actions from "rdx/actions";
import makeRequest from "rdx/utils/makeRequest";
import SessionClient from "util/SessionClient";
import getErrorActions from "rdx/utils/getErrorActions";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* reopenIssue(action) {
  const { id } = action.payload;
  const { success, data, error } = yield* makeRequest.post(`/messages/${id}/reopen`, {});

  if (success && data) {
    const message = keysToCamelCase(data.body);

    // Update Project Notice List and Inbox List on reopen
    const currentPNList = yield select(selectors.getProjectMessageList);
    const currentIBList = yield select(selectors.getInboxList);
    const newPNList = currentPNList.map((n) => (n.id === id ? { ...message, counters: n.counters } : n));
    const newIBList = currentIBList.map((n) => (n.id === id ? { ...message, counters: n.counters } : n));

    // Update issue count in rbac rdx module if user is assignee
    const session = new SessionClient();
    const currentInboxCount = yield select(rbacSelectors.getInboxCount);
    const newInboxCount = session.isSessionUser(message.assignee?.id) ? currentInboxCount + 1 : currentInboxCount;

    yield all([
      put(actions.setProjectMessageList({ list: newPNList })),
      put(actions.setInboxList({ list: newIBList })),
      put(actions.setSelectedMessageDetails(message)),
      put(actions.updateInboxCount(newInboxCount)),
      put(
        actions.newSuccessEvent({
          message: messages.REOPEN_PROJECT_MESSAGE_SUCCESS,
        }),
      ),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_REOPENING_PROJECT_MESSAGE,
    });
  }
  return null;
}

export default reopenIssue;
